import * as Yup from "yup";

export const formDataObject = {
  chassisNo: "",
  enginNo: "",
};

export const validationSchema = Yup.object().shape({});
